import styled from "styled-components";
import buildColor from "../../_static/ColorPalette";
import { fontNormal } from "../../_static/Typography";

export const Container = styled.div`
  background-color: ${buildColor("white", "100")};
  padding: 16px 12px;
`;
export const Text = styled.p`
  font-size: 14px;
  line-height: 18px;
  color: ${buildColor("grey", "800")};
  font-family: ${fontNormal};

  &:not(:last-child) {
    margin-bottom: 18px;
  }
`;
